import { reactive } from 'vue'

export const networkSpeed = reactive({ googleSpeed: 0, customSpeed: 0 })

// 使用特定的图片资源测试当前网络下载速度
export function measureNetworkSpeed(url, fileSizeInBytes) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now() // 记录开始时间

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`网络请求失败: ${response.statusText}`)
        }
        return response.blob() // 将响应转换为 Blob 对象
      })
      .then((blob) => {
        const endTime = Date.now() // 记录下载完成时间
        const duration = (endTime - startTime) / 1000 // 计算下载时间（秒）
        const speed = fileSizeInBytes / duration / 1024 // 计算下载速度（KB/s）
        resolve(Number(speed.toFixed(2))) // 返回下载速度，保留两位小数
      })
      .catch((err) => {
        reject(new Error(`下载失败: ${err.message}`))
      })
  })
}

function getFileSize(url) {
  return new Promise((resolve, reject) => {
    fetch(url, { method: 'HEAD' })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HEAD 请求失败: ${response.statusText}`)
        }
        const contentLength = response.headers.get('Content-Length')
        if (!contentLength) {
          throw new Error('无法获取文件大小')
        }
        resolve(parseInt(contentLength, 10))
      })
      .catch((err) => {
        reject(new Error(`获取文件大小失败: ${err.message}`))
      })
  })
}

export async function getNetworkSpeed() {
  const customUrl =
    'https://static.playturbo.cn/playturbo/record/src/assets/icon-ve-loding.png'
  const googleCdnUrl =
    'https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js'
  try {
    // 获取 Google CDN 文件大小
    const googleFileSize = await getFileSize(googleCdnUrl)

    // 获取自定义 URL 文件大小
    const customFileSize = await getFileSize(customUrl)
    // 测试 Google CDN 速度
    networkSpeed.googleSpeed = await measureNetworkSpeed(
      googleCdnUrl,
      googleFileSize,
    )
    // 测试自定义 URL 速度
    networkSpeed.customSpeed = await measureNetworkSpeed(
      customUrl,
      customFileSize,
    )
  } catch (err) {
    throw new Error(`测试失败: ${err.message}`)
  }
}

// 资源加载速度测算
getNetworkSpeed()

// 辅助函数：获取图片的文件大小（字节）
function getImageFileSize(img: HTMLImageElement): number {
  try {
    const xhr = new XMLHttpRequest()
    xhr.open('HEAD', img.src, false) // 同步请求
    xhr.send(null)
    const contentLength = xhr.getResponseHeader('Content-Length')
    return contentLength ? parseInt(contentLength, 10) : 0
  } catch (error) {
    console.error('获取文件大小失败:', error)
    return 0
  }
}
